import common from './common'
import {
  post,
  get,
  postForm,
  postJson,
  getJson,
  postJsonForLongTimeout,
  getBase64data,
  getExcel,
  postImg
} from './http.js'

import { getUnionLink } from './utils'
import { Toast, Dialog } from 'vant'

const union_utils = {}

union_utils.getUrl = function (url, fn) {
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 处理ubb标签
 * @param url
 * @returns {*}
 */
union_utils.handleUbb = function (content) {
  if (content) {
    content = content.replace(new RegExp('\\[yyyyMMdd\\]', 'gm'), common.dateFmt('yyyyMMdd', new Date()).toString())
    return content
  }
}

union_utils.getActivityImage = function (imgList, imgTag) {
  if (imgTag && imgList && imgList.length > 0) {
    for (let i in imgList) {
      let w = imgList[i].widthHeight
      let imgUrl = imgList[i].imgUrl
      if (imgTag === w) {
        return imgUrl
      }
    }
  }
}

union_utils.getActivityUnionLink = function (actData, fn) {
  if (actData) {
    let _positionId = common.getPid()
    let _data = {
      app_key: common.getAppKeyInfo('70637').app_key,
      app_secret: common.getAppKeyInfo('70637').app_secret,
      materialId: actData.urlM,
      subUnionId: '',
      positionId: _positionId, //推广位ID
      chainType: 2,
    }
    getUnionLink(_data, res => {
      if (res.code === 200) {
        if (fn) {
          fn(res.data.shortURL)
        }
      }
    })
  }
}

union_utils.jumpUrl = function (url) {
  if (url) {
    if (common.isWx_mini()) {
      union_utils.showCopyDialog('提示', '复制地址,在微信(推荐)或浏览器中打开:\n' + url, url)
    } else {
      location.href = url
    }
  }
}

//复制内容的弹窗
union_utils.showCopyDialog = function (title, message, copyText) {
  Dialog.confirm({
    title: title,
    message: message,
    confirmButtonColor: 'red',
    confirmButtonText: '复制'
  }).then(() => {
    union_utils.copyToClipboard(copyText, success => {
      this.toast = Toast.success({
        message: '复制成功',
      })
    }, error => {
      this.toast = Toast.fail({
        message: '复制失败',
      })
    })
  }).catch(() => {
    console.log('点击了取消')
  })
}

union_utils.copyToClipboard = function (text, success, error) {
  if (text) {
    window.navigator.clipboard
      .writeText(text)
      .then(() => {
        window.navigator.clipboard.readText().then((clipText) => {
          if (clipText === text) {
            if (success) {
              success()
            }
          } else {
            if (error) {
              error()
            }
          }
        })
      })
      .catch((err) => {
        if (error) {
          error(err)
        }
      })
  }
}

export default union_utils